<label for="{{inputId}}" class="form-label {{customClass}}" [ngClass]="{required: isMandatory}">
  {{labelKey|translate}}
</label>
